var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDropUpOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70175 13.7018L6.70175 10.7018C6.89474 10.5263 7 10.2807 7 10C7 9.45614 6.54386 9 6 9C5.7193 9 5.47368 9.10526 5.29825 9.29825L2.29825 12.2982C2.10526 12.4737 2 12.7193 2 13C2 13.5439 2.45614 14 3 14C3.2807 14 3.52632 13.8947 3.70175 13.7018ZM5.29825 10.7018L8.29825 13.7018C8.47368 13.8947 8.7193 14 9 14C9.54386 14 10 13.5439 10 13C10 12.7193 9.89474 12.4737 9.70175 12.2982L6.70175 9.29825C6.52632 9.10526 6.2807 9 6 9C5.45614 9 5 9.45614 5 10C5 10.2807 5.10526 10.5263 5.29825 10.7018ZM9 12H3C2.45614 12 2 12.4561 2 13C2 13.5439 2.45614 14 3 14H9C9.54386 14 10 13.5439 10 13C10 12.4561 9.54386 12 9 12ZM3 13H9L6 10L3 13Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropUpOutlined);
export default __webpack_public_path__ + "static/media/arrow_drop_up_outlined.77fd776c.svg";
export { ForwardRef as ReactComponent };